import React, { useEffect, useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Alert,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { postProcessoSuccess, resetProccessMessages } from "store/actions"

const ModalAddProcesso = ({
  toggleModal,
  showModal,
  inputs,
  setInputs,
  isValidInputs,
  setIsValidInputs,
}) => {
  const responseMessage = useSelector(state => state.Processo.response)
  const dispatch = useDispatch()

  const [isMulti, setIsMulti] = useState(false)
  const [multiInput, setMultiInput] = useState("")
  const [isMultiInputValid, setIsMultiInputValid] = useState(false)
  const [numProcessos, setNumProcessos] = useState(0)
  const [loading, setLoading] = useState(false)

  const handleInputChange = (index, event) => {
    const { name, value } = event.target
    const newInputs = [...inputs]
    newInputs[index][name] = value
    setInputs(newInputs)
    validateInputs(index)
  }

  const handleSubmit = () => {
    const processos = inputs.map(input => ({
      numeroCNJ: input.number,
      observacao: input.observations,
      status: "Manual",
    }))

    dispatch(postProcessoSuccess(processos))
    setLoading(true)
    setInputs([{ number: "", observations: "" }])
  }

  const handleSubmitMultiProcess = () => {
    const processos = multiInput.split("\n").map(processo => {
      return {
        numeroCNJ: processo.trim(),
        observacao: "",
        status: "Manual",
      }
    })

    setMultiInput("")

    dispatch(postProcessoSuccess(processos))
    setLoading(true)
  }

  useEffect(() => {
    const count = multiInput
      .split("\n")
      .filter(line => line.trim() !== "").length
    setNumProcessos(count)
  }, [multiInput])

  useEffect(() => {
    setLoading(false)
    const timeout = setTimeout(() => {
      dispatch(resetProccessMessages())
      if (responseMessage) {
        toggleModal()
        setIsMulti(false)
      }
    }, 3000)

    return () => clearTimeout(timeout)
  }, [responseMessage, dispatch])

  const validateNumeroCNJ = value => {
    const regex = /^[0-9./-]*$/
    return value.length >= 11 && regex.test(value)
  }

  const validateInputs = index => {
    const isValid = validateNumeroCNJ(inputs[index].number)
    const newIsValidInputs = [...isValidInputs]
    newIsValidInputs[index] = isValid
    setIsValidInputs(newIsValidInputs)
  }

  const validateMultiInput = inputValue => {
    return inputValue
      .split("\n")
      .every(processo => validateNumeroCNJ(processo.trim()))
  }

  return (
    <Modal isOpen={showModal} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Cadastrar novo</ModalHeader>
      <div className="d-flex justify-content-start p-2">
        <Button
          color="secondary"
          onClick={() => setIsMulti(false)}
          active={!isMulti}
        >
          Processo
        </Button>
        <Button
          color="secondary"
          className="ms-2"
          onClick={() => setIsMulti(true)}
          active={isMulti}
        >
          Múltiplos Processos
        </Button>
      </div>

      {responseMessage?.message === "Processo cadastrado com sucesso." ||
      responseMessage?.message ===
        "Todos os processos foram cadastrados com sucesso." ? (
        <Alert color="success">{responseMessage?.message}</Alert>
      ) : (
        responseMessage !== null && (
          <Alert color="danger">{responseMessage?.message}</Alert>
        )
      )}

      {isMulti ? (
        <ModalBody>
          <FormGroup>
            <Label for="multiInput">Lista de Processos</Label>
            <Input
              type="textarea"
              name="multiInput"
              id="multiInput"
              placeholder="Insira os processos (um por linha)"
              value={multiInput}
              onChange={e => {
                setMultiInput(e.target.value)
                setIsMultiInputValid(validateMultiInput(e.target.value))
              }}
              rows={5}
              valid={isMultiInputValid}
              invalid={!isMultiInputValid && multiInput.trim().length > 0}
            />
            <FormFeedback invalid>
              O número CNJ deve ter 11 caracteres e conter apenas números,
              pontos, traços ou barras.
            </FormFeedback>
          </FormGroup>
          <span>{numProcessos} processos</span>
        </ModalBody>
      ) : (
        <ModalBody>
          {inputs.map((input, index) => (
            <div key={index}>
              <Form>
                <FormGroup>
                  <Label for={`number_${index}`}>Número *</Label>
                  <Input
                    type="text"
                    name="number"
                    id={`number_${index}`}
                    placeholder="Número do processo"
                    value={input.number}
                    onChange={event => {
                      handleInputChange(index, event)
                      validateInputs(index)
                    }}
                    valid={isValidInputs[index]}
                    invalid={input.number.length > 0 && !isValidInputs[index]}
                  />
                  <FormFeedback invalid>
                    O número CNJ deve ter 11 caracteres e conter apenas números,
                    pontos, traços ou barras.
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for={`observations_${index}`}>Observações</Label>
                  <Input
                    type="textarea"
                    name="observations"
                    id={`observations_${index}`}
                    placeholder="Observações"
                    value={input.observations}
                    onChange={event => handleInputChange(index, event)}
                    valid={input.observations.length > 0}
                  />
                </FormGroup>
              </Form>
            </div>
          ))}
        </ModalBody>
      )}
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>
          Cancelar
        </Button>
        <Button
          color="success"
          onClick={isMulti ? handleSubmitMultiProcess : handleSubmit}
          disabled={
            !isMulti
              ? !isValidInputs.every(isValid => isValid)
              : multiInput.length < 25
          }
        >
          <i
            className={loading && "bx bx-loader bx-spin align-middle me-2"}
          ></i>
          {loading ? "Cadastrando..." : "Cadastrar"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalAddProcesso
